import React from "react";

export const F1CarSVG = ({
  direction = "ltr",
  primary = "#e10600",
  accent = "#ffffff",
  startY = "30vh",
  duration = 5,
  delay = 0,
}) => {
  const anim =
    direction === "ltr"
      ? `animate-[carFlyL_${duration}s_ease-in-out_${delay}s_1]`
      : `animate-[carFlyR_${duration}s_ease-in-out_${delay}s_1]`;

  return (
    <div className="pointer-events-none absolute" style={{ top: startY, left: direction === "ltr" ? 0 : "auto", right: direction === "rtl" ? 0 : "auto" }}>
      <style>{`
        @keyframes carFlyL {0%{transform:translateX(-40vw)}100%{transform:translateX(120vw)}}
        @keyframes carFlyR {0%{transform:translateX(120vw)}100%{transform:translateX(-40vw)}}
        @keyframes wheelSpin {to{transform:rotate(360deg)}}
        @keyframes smoke {0%{transform:translateX(0) translateY(0) scale(.6);opacity:.6}100%{transform:translateX(-40px) translateY(-20px) scale(1.3);opacity:0}}
        @keyframes speedLine {0%{transform:translateX(0);opacity:.9}100%{transform:translateX(160px);opacity:0}}
      `}</style>

      <div className={`relative w-[200px] h-[70px] ${anim}`} style={{ willChange: "transform" }}>
        <div className="absolute top-6 -right-24 h-1 w-24 bg-white/70 blur-[2px] animate-[speedLine_0.5s_linear_infinite]" />
        <div className="absolute top-10 -right-20 h-0.5 w-20 bg-white/50 blur-[1px] animate-[speedLine_0.6s_linear_infinite]" />
        {/* SVG del auto */}
        <svg width="200" height="70" viewBox="0 0 200 70" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g>
            <circle cx="46" cy="56" r="14" fill="#111" stroke="#555" strokeWidth="3"/>
            <circle cx="46" cy="56" r="6" fill="#222"/>
            <g transform="translate(32,42)">
              <g style={{transformOrigin:'14px 14px'}} className="animate-[wheelSpin_0.55s_linear_infinite]">
                <circle cx="14" cy="14" r="14" fill="transparent"/>
                {[...Array(6)].map((_,i)=> (
                  <rect key={i} x="13" y="1" width="2" height="8" fill="#ccc" transform={`rotate(${i*60} 14 14)`} />
                ))}
              </g>
            </g>
          </g>
          <g>
            <circle cx="162" cy="56" r="14" fill="#111" stroke="#555" strokeWidth="3"/>
            <circle cx="162" cy="56" r="6" fill="#222"/>
            <g transform="translate(148,42)">
              <g style={{transformOrigin:'14px 14px'}} className="animate-[wheelSpin_0.55s_linear_infinite]">
                <circle cx="14" cy="14" r="14" fill="transparent"/>
                {[...Array(6)].map((_,i)=> (
                  <rect key={i} x="13" y="1" width="2" height="8" fill="#ccc" transform={`rotate(${i*60} 14 14)`} />
                ))}
              </g>
            </g>
          </g>
          <rect x="0" y="45" width="40" height="4" fill={accent} opacity="0.9" />
          <rect x="6" y="41" width="24" height="3" fill={accent} opacity="0.7" />
          <path d="M40 48 C55 38, 85 36, 110 36 L140 36 C150 36, 160 38, 168 42 L175 46 L175 50 L168 52 C160 56, 150 58, 140 58 L110 58 C85 58, 55 54, 40 48 Z" fill={primary} />
          <rect x="96" y="30" width="18" height="6" rx="3" fill={accent} opacity="0.9" />
          <ellipse cx="104" cy="44" rx="10" ry="6" fill="#0b0b0b" stroke={accent} strokeWidth="2" />
          <rect x="176" y="36" width="18" height="16" rx="2" fill={accent} opacity="0.95" />
          <rect x="176" y="32" width="18" height="3" fill={accent} opacity="0.6" />
          <rect x="122" y="40" width="12" height="4" fill="#111" opacity=".6" />
          <rect x="132" y="42" width="8" height="3" fill="#111" opacity=".5" />
        </svg>

        <span className="absolute bottom-[6px] left-[146px] w-3 h-3 rounded-full bg-white/50 blur-[1px] animate-[smoke_1.2s_ease-out_infinite]" />
        <span className="absolute bottom-[10px] left-[150px] w-2.5 h-2.5 rounded-full bg-white/40 blur-[1px] animate-[smoke_1.1s_ease-out_infinite_0.2s]" />
      </div>
    </div>
  );
};
